export default __webpack_public_path__ + "static/media/Best pick up line.a57456f1.jpg";